import { Middleware, RequestContext, ResponseContext } from '../../api/core';
import { Actions } from './interfaces';

export const getAuthMiddleware = (actions: Actions): Middleware => ({
  pre: async (ctx: RequestContext): Promise<RequestContext> => {
    const token: string = await actions.getAuthTokenOrRefresh(false);
    if (!!token) {
      ctx.init.headers = setHeader(ctx.init.headers || null, 'Authorization', token);
    }
    return ctx;
  },
  post: async ({fetch, url, init, response}: ResponseContext): Promise<Response> => {
    if (response.status === 401) {
      const resJson = await response.json().catch((_): null => null);
      if (!resJson || !resJson.error || resJson.error === 'invalid_token') {
        // The access_token probably expired, try again once with a new one
        const token: string = await actions.getAuthTokenOrRefresh(false);
        if (!!token) {
          init.headers = setHeader(init.headers || null, 'Authorization', token);
          return await fetch(url, init);
        }
      }
    }
    return response;
  },
});

const setHeader = (headers: HeadersInit, key: string, value: string): Headers => {
  const newHeaders: Headers = new Headers(headers);
  newHeaders.set(key, value);
  return newHeaders;
};
